import type { StaticImageData } from 'next/image';

import { z } from 'zod';

export const EVENT_TYPES = [
  'Challenge',
  'Community meetup',
  'Lecture',
  'Hackathon',
  'Panel',
  'Workshop',
];

export const EVENT_FORMATS = ['In person', 'Virtual'];

export const EVENT_AUDIENCE = ['Public', 'Club members', 'University students'];

export const FallFestEventSchema = z
  .object({
    id: z.string(),
    University: z.string(),
    Location: z.string().optional(),
    Country: z.string().optional(),
    'Event start': z.coerce.date().optional(),
    'Event format': z.array(z.string()).optional(),
    'Event link': z.string().optional(),
    'Who will your event be open to?': z.string().optional().or(z.array(z.string())).optional(),
    'Event type': z.string().optional().or(z.array(z.string())).optional(),
  })
  .transform((event) => {
    const tags: string[] = [];

    if (event['Who will your event be open to?']) {
      const eventAudienceTypes = Array.isArray(event['Who will your event be open to?'])
        ? event['Who will your event be open to?']
        : [event['Who will your event be open to?']];
      tags.push(...eventAudienceTypes);
    }

    if (event['Event format']) {
      const eventFormatTags = event['Event format'];

      // if Event has both 'In person' or 'Virtual' tags, provide the 'In person & virtual' tag
      if (eventFormatTags.length === 2) {
        tags.push('In person & virtual');
      }
      eventFormatTags.forEach((eventFormat: string) => {
        tags.push(eventFormat);
      });
    }

    return {
      id: event['id'],
      name: event['University'],
      startDate: event['Event start'],
      startDateFormat: event['Event start'] ? 'date' : 'datetime',
      location: event['Location'],
      country: event['Country'],
      link: event['Event link'],
      tags,
    };
  });

export type FallFestQuantumEvent = z.infer<typeof FallFestEventSchema>;

export type FallFestQuantumEventWithImage = FallFestQuantumEvent & { image: StaticImageData };
